import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import { deleteFromWishlist } from "../../../../_services/Arya2.0/MyWishlist";
import { addToWishlist } from "../../../../_services/Arya2.0/MyWishlist/api";
import Loader from "../CommonComponents/Loader/Loader";
import { customToastr } from "../CustomToastr";
import CommonSupplies from "./CommonSupplies";
import { useTranslation } from "react-i18next";
import { eventTracker } from "../GATracker3.0/eventTracker";
import { BOOK_WAREHOUSE_BANNER_CLICKED } from "../GATracker3.0/constants";
import { isMobile } from "../helperFunc";
import style from "./style.module.css";
const WarehouseNearMe = (props) => {
  const { t: translation } = useTranslation();
  const [data, setData] = useState([]);
  const [dataObj, setDataObj] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    commonApiCall();
  }, []);
  const history = useHistory();
  const location = useLocation();

  const filterData = (dataArray) => {
    let newData = [];
    dataArray.map((item) => {
      let newObj = {};
      newObj.aryaCertified =
        item.warehouse_details.arya_certified == 1 ? true : false;
      newObj.warehouseWidget = true;
      newObj.address = item.address.city_lang + ", " + item.address.state_lang;
      newObj.rows = [
        item.name,
        newObj.aryaCertified
          ? parseFloat(
              item.warehouse_details.current_capacity_available
            ).toLocaleString("en-IN") +
            " MT " +
            translation("Available")
          : parseFloat(
              item.warehouse_details.warehouse_capacity
            ).toLocaleString("en-IN") +
            " MT " +
            translation("Total Capacity"),
      ];
      newObj.address2 =
        item.warehouse_details.apmc_distance +
        " " +
        translation("Kms from APMC Mandi");
      newObj.image = item?.multimedia?.length ? item?.multimedia[0] : "";
      newObj.url = "/warehouse/" + item.warehouse_slug + "/" + item.id;
      newObj.lead_id = item.id;
      newObj.isBookMarked = item.is_in_wishlist;
      newData.push(newObj);
    });
    setData(newData);
  };
  const commonApiCall = async (
    offset = 0,
    limit = 10,
    searchdata,
    filters,
    key
  ) => {
    setIsLoading(true);
    let pincode = "";
    var response = await HomePageServices.displayWareHouse(
      offset,
      limit,
      searchdata,
      filters,
      pincode
    );
    setIsLoading(false);

    props.setApiHitCount && props.setApiHitCount();

    if (response?.data?.data) {
      setDataObj(response.data.data);
      filterData(response.data.data);
    } else {
      // setLoader(false);
    }
  };

  const onSimilarLeadHeartClick = async (e, lead_id) => {
    e.preventDefault();
    e.stopPropagation();
    let index = data.findIndex((el) => el.lead_id == lead_id);
    if (index < 0) return;
    //if lead is bookmarked
    if (data[index].isBookMarked) {
      setIsLoading(true);

      try {
        const res = await deleteFromWishlist({
          object_id: lead_id,
          object_type: "warehouse",
        });

        if (res.status_code == 200) {
          data[index].isBookMarked = false;
          customToastr({ text: "Removed from favourites" });

          setData([...data]);
        }
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
      //call delete api
      // await
      // similarLeadData[index];
    } else {
      let payload = {
        object_id: lead_id,
        object_type: "warehouse", //auctions,warehouse,supplies,demands
      };
      // add to bookmark
      setIsLoading(true);
      try {
        const res = await addToWishlist(payload);
        if (res.status_code == 200) {
          data[index].isBookMarked = true;
          customToastr({ text: "Added to favourites" });

          setData([...data]);
        }
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      {dataObj ? (
        <CommonSupplies
          title="Warehouse Near Me"
          subtitle={"Find & Book Warehouse for your commodities"}
          data={data}
          // location={true}
          dataObj={dataObj}
          zoomIndex={isMobile ? 3.2 : 6}
          bookMarkClass="warehousebookMark"
          widget="warehouseNearMe"
          onHeartClick={onSimilarLeadHeartClick}
          onClick={() => {
            eventTracker("event", BOOK_WAREHOUSE_BANNER_CLICKED, {
              pagename:
                location.pathname === "/" ? "homepage" : location.pathname,
            });
            history.push("/warehouse/find-a-warehouse");
          }}
          locationText2ClassName={"margin-top4 padding-top1"}
          isWarehouseDesktop={!isMobile}
          leftArrowClassName={style["left-arrow-warehouse"]}
          rightArrowClassName={style["right-arrow-warehouse"]}
        />
      ) : (
        ""
      )}
    </>
  );
};
export default WarehouseNearMe;
